import React from 'react';
import { Box, Tabs, Tab, styled } from '@mui/material';
import PropTypes from 'prop-types';

const TabsWrapper = styled(Box)(({ theme }) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  marginBottom: theme.spacing(3)
}));

const FilterTabs = ({ activeTab, onTabChange }) => {
  return (
    <TabsWrapper>
      <Tabs 
        value={activeTab}
        onChange={(e, newValue) => onTabChange(newValue)}
        indicatorColor="primary"
        textColor="primary"
      >        <Tab 
          value="all" 
          label="All Jobs"
        />
        <Tab 
          value="valid"
          label="Valid" 
        />
        <Tab 
          value="remarked" 
          label="Remarked" 
        />
      </Tabs>
    </TabsWrapper>  );
};

FilterTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired
};

export default FilterTabs;
